import 'slick-carousel';
import 'selectize';
import hero from '../modules/hero.js';
import gallery from '../modules/gallery.js';
import navigation from '../modules/navigation.js';
import searchform from '../modules/searchform.js';
import listing from '../modules/listing.js';
import animations from '../modules/animations.js';
import aos from '../modules/aos.js';

export default {
  init() {
    aos();
    hero();
    gallery();
    navigation();
    searchform();
    listing();
    animations();

    // Back to the top of the page
    $('[data-arrow-up]').click(function(e){
      e.preventDefault();
      $('html, body').animate({scrollTop : 0}, 1500);
    });

    // Smooth hero arrow
    $('[data-go-projects]').click(function(event){
      event.preventDefault();
      $('html,body').animate({scrollTop:$(this.hash).offset().top}, 800);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js